import { memo } from "react";
import MaxWidthLayout from "./MaxWidthLayout";

const TitleIntroduce = () => {
  return (
    <MaxWidthLayout>
      <div className="text-center text-black-1">
        <h2 className="text-26px md:text-4xl text-green-1 font-semibold pb-16px md:pb-24px pt-24px mb:pt-0">
          與米啟航 乘風破浪
        </h2>
        <h3 className="text-lg md:text-28px text-black font-semibold pb-8px md:pb-16px">
          Meteor 夢想輸送帶，求學路上築夢踏實
        </h3>
        <p className="text-14px md:text-xl whitespace-normal md:whitespace-pre-wrap max-w-305px md:max-w-1440px m-auto">
          前往夢想的道路總有許多挑戰，唯有堅持不懈，才能贏來豐收的果實。
          <br className="hidden md:block" />
          期許同學們在求學路上不畏風雨，乘風破浪，讓Meteor成為你前往夢想的輸送帶，伴你築夢。
        </p>
      </div>
    </MaxWidthLayout>
  );
};
export default memo(TitleIntroduce);
